<template>
  <div>
    <base-confirm
      v-if="visible"
      @close="$emit('close')"
      @confirmed="onConfirmed"
      size="max-w-xl"
      :message="hasStockMovement ? 'Sudah ada faktur pengemasan. Anda yakin ingin membatalkan?' : 'Anda yakin ingin membatalkan?'"
      type="danger"
      icon-type="badge"
      title="Batalkan Faktur Penjualan"
      confirm-text="Ya"
      cancel-text="Tutup"
      visible
    >
      <template #content>
        <base-input inset label="Alasan pembatalan" placeholder="Alasan pembatalan" tag="textarea" rows="4" v-model="description" />
      </template>
    </base-confirm>
    <loading v-if="loading" />
  </div>
</template>

<script>
import BaseConfirm from '@/components/base/BaseConfirm.vue';
import { requestMixin } from '@/mixins/request/request';
import { mapActions } from 'vuex';

export default {
  components: { BaseConfirm },
  mixins: [requestMixin],
  props: {
    visible: Boolean,
    hasStockMovement: Boolean,
    orderId: String,
  },
  emits: ['close', 'confirmed'],
  data() {
    return {
      loading: false,
      description: null
    };
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert',
    }),
    async onConfirmed() {
      this.loading = true;

      const [, err] = await this.request(
        `/api/v1/orders/${this.orderId}/-actions/cancel-stock-movement`,
        {
          method: 'patch',
          data: {
            description: this.description,
          }
        }
      );

      if (err) {
        this.createAlert({
          data: this.getRequestErrorMessage(err),
          status: 'error',
        });
      } else {
        this.$emit('confirmed');
      }

      this.loading = false;
    },
  },
};
</script>
